// Modules
import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledSpan = styled.span<{ valid: boolean | undefined }>`
    font-size: 12px;
    color: ${({ valid }): string => {
        if (valid === undefined) {
            return theme.colors.grays[50]
        }
        if (valid) {
            return theme.colors.greens[40]
        }
        return theme.colors.reds[50]
    }};
`
